import React from 'react';
import Footer from '../components/Footer';

const PrivacyPolicy: React.FC = () => {
  return (
    <>
      <section className='legal-content'>
        <h1 className='titles large color black'>Privacy Policy</h1>
        <p className='paragraphs medium color dark-charcoal'><em>Last updated: June 17, 2025.</em></p>

        <p className='paragraphs medium color dark-charcoal'>This Privacy Policy describes how <strong>Appetite App Ltd</strong> (ABN 46290838577) ("we", "us", or "our") collects, uses, discloses, and protects your personal information when you use our mobile application and website (together, the "Service").</p>

        <p className='paragraphs medium color dark-charcoal'>By accessing or using the Service, you consent to the practices described in this Privacy Policy.</p>

        <h2 className='titles small color dark-charcoal'>1. Information We Collect</h2>
        <ul className='paragraphs medium color dark-charcoal'>
          <li><strong>Personal Identifiers:</strong> First name, last name, and email address when you register an account.</li>
          <li><strong>Account Information:</strong> Membership type (free or paid), and subscription status.</li>
          <li><strong>User Content:</strong> Photos you upload to the Service (stored securely via Cloudinary).</li>
          <li><strong>Usage Data:</strong> Analytics data such as device information, usage logs, interaction events, and error reports.</li>
          <li><strong>Payment Information:</strong> Payments are processed through Stripe. We do not store any credit card or billing details.</li>
        </ul>

        <h2 className='titles small color dark-charcoal'>2. How We Use Your Information</h2>
        <ul className='paragraphs medium color dark-charcoal'>
          <li>Provide and maintain the Service;</li>
          <li>Manage subscriptions and account access;</li>
          <li>Improve app functionality and user experience;</li>
          <li>Communicate with you, including sending notifications and emails (which you can opt out of);</li>
          <li>Detect and prevent fraud, abuse, or violations of our terms;</li>
          <li>Comply with legal obligations.</li>
        </ul>

        <h2 className='titles small color dark-charcoal'>3. How We Share Your Information</h2>
        <p className='paragraphs medium color dark-charcoal'>We do not sell your personal information. We may share limited personal data with:</p>
        <ul className='paragraphs medium color dark-charcoal'>
          <li><strong>Service Providers:</strong> Including Supabase (data storage and authentication), Stripe (payment processing), Cloudinary (media hosting), Mux (video hosting), SendGrid (email communication), and Mixpanel (analytics).</li>
          <li><strong>Creators:</strong> The content creators you subscribe to can only see your name, profile picture, and any posts you choose to make within their community.</li>
          <li><strong>Legal Authorities:</strong> If required by law or in response to valid legal requests.</li>
        </ul>

        <h2 className='titles small color dark-charcoal'>4. International Data Transfers</h2>
        <p className='paragraphs medium color dark-charcoal'>As we operate globally, your personal data may be processed in countries outside your place of residence. We ensure that such transfers are lawful and that your information is protected under applicable data protection laws.</p>

        <h2 className='titles small color dark-charcoal'>5. Data Security</h2>
        <p className='paragraphs medium color dark-charcoal'>We take reasonable steps to protect your personal information, including using secure servers, encryption (provided by our third-party services), and access controls. Only authorized personnel (founders and engineers) have access to your data.</p>

        <h2 className='titles small color dark-charcoal'>6. Cookies and Tracking Technologies</h2>
        <p className='paragraphs medium color dark-charcoal'>We may use cookies and similar technologies in the future to improve our Service and gather usage statistics. You will be notified and given the option to manage cookie preferences when these are implemented.</p>

        <h2 className='titles small color dark-charcoal'>7. Children’s Privacy</h2>
        <p className='paragraphs medium color dark-charcoal'>Our Service is not directed to children under 13 (or under 16 in some jurisdictions). We do not knowingly collect personal data from minors. If we become aware of such data collection, we will delete it promptly.</p>

        <h2 className='titles small color dark-charcoal'>8. Your Rights</h2>
        <p className='paragraphs medium color dark-charcoal'>Depending on your location, you may have rights under data protection laws including:</p>
        <ul className='paragraphs medium color dark-charcoal'>
          <li>Access to your personal data;</li>
          <li>Correction of incorrect or outdated information;</li>
          <li>Deletion of your personal data;</li>
          <li>Data portability;</li>
          <li>Objection or restriction to certain data uses.</li>
        </ul>
          <p className='paragraphs medium color dark-charcoal'>To exercise these rights, please contact us at the email below.</p>

        <h2 className='titles small color dark-charcoal'>9. Marketing and Communication Preferences</h2>
        <p className='paragraphs medium color dark-charcoal'>We may send you push notifications and emails about your account, updates, or promotions.</p>
        <ul className='paragraphs medium color dark-charcoal'>
          <li>Disable push notifications via your device settings;</li>
          <li>Unsubscribe from emails using the opt-out link provided in each email.</li>
        </ul>

        <h2 className='titles small color dark-charcoal'>10. Data Retention</h2>
        <p className='paragraphs medium color dark-charcoal'>We retain your personal data as long as necessary to provide the Service, comply with our legal obligations, resolve disputes, and enforce our agreements.</p>

        <h2 className='titles small color dark-charcoal'>11. Changes to This Policy</h2>
        <p className='paragraphs medium color dark-charcoal'>We may update this Privacy Policy from time to time. We will notify you of significant changes by posting the updated version on our website and updating the “Last Updated” date. Your continued use of the Service constitutes your acceptance of the updated policy.</p>

        <h2 className='titles small color dark-charcoal'>12. Contact Us</h2>
        <p className='paragraphs medium color dark-charcoal'>If you have any questions or requests regarding this Privacy Policy or your personal information, please contact:</p>
        <p className='paragraphs medium color dark-charcoal'>
          <strong>Appetite App Ltd</strong><br />
          Email: <a href='mailto:support@appetiteapp.com'>support@appetiteapp.com</a><br />
          Postal: 123 Main St, Melbourne, VIC 3000, Australia
        </p>
      </section>
      <Footer />
    </>
  );
};

export default PrivacyPolicy; 